import axios from "axios";

/**
 * Vueのコンポーネント直下から参照したい場合はこちらのaxiosプラグインを使用する
 */
export default class axiosObject {
    
    /**
     * 
     * @param {*} app 
     * @param {*} options 
     */
    static install = (app) => {
        app.prototype.$axios = axios.create({
            baseURL: location.origin + "/api",
            headers: {
              'Content-Type': 'application/json'
            },
            responseType: 'json',
            timeout: 3000
        })
        
        // リクエストログ
        app.prototype.$axios.interceptors.request.use(
            function (config) {
              console.info(config)
              return config;
            },
            function (error) {
              console.error(error)
              return Promise.reject(error);
            }
        )
        
        // レスポンスログ
        app.prototype.$axios.interceptors.response.use(
            function (response) {
              console.info(response)
              return response;
            },
            function (error) {
              console.error(error)
              return Promise.reject(error);
            }
        )
    }
}
